var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUserGroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icUserGroup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.44266338,7.86035302 C6.10890916,8.13843614 5.84102507,8.4991533 5.67228073,8.92 C5.61418529,9.06488944 5.58433338,9.21955198 5.58433338,9.37565461 C5.58433338,9.7790849 5.77945655,10.1369417 6.08047778,10.36 L3.47638768,10.36 C2.89596034,10.36 2.42543101,9.88947067 2.42543101,9.30904332 C2.42543101,9.17580197 2.45076768,9.04377589 2.50009099,8.92 C2.84657716,8.05049966 3.68804218,7.48 4.62403551,7.48 L5.1201222,7.48 C5.59770821,7.48 6.05391786,7.61658386 6.44266338,7.86035302 Z M8.39591753,7.24 L8.99742653,7.24 C10.129103,7.24 11.1585295,7.89493602 11.6380454,8.92 C11.9141846,9.51030422 11.6595034,10.2126953 11.0691992,10.4888345 C10.912684,10.5620509 10.7419988,10.6 10.5692051,10.6 L7.04867878,10.6 C6.37249149,10.6 5.82433338,10.0518419 5.82433338,9.37565461 C5.82433338,9.21955198 5.85418529,9.06488944 5.91228073,8.92 C6.31918619,7.90518186 7.30256126,7.24 8.39591753,7.24 Z M8.56,6.52 C7.69843579,6.52 7,5.82156421 7,4.96 C7,4.09843579 7.69843579,3.4 8.56,3.4 C9.42156421,3.4 10.12,4.09843579 10.12,4.96 C10.12,5.82156421 9.42156421,6.52 8.56,6.52 Z M4.96,7 C4.36353247,7 3.88,6.51646753 3.88,5.92 C3.88,5.32353247 4.36353247,4.84 4.96,4.84 C5.55646753,4.84 6.04,5.32353247 6.04,5.92 C6.04,6.51646753 5.55646753,7 4.96,7 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Feedback-react-JS",
    transform: "translate(-150.000000, -2713.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icUserGroup",
    transform: "translate(150.000000, 2713.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    fill: "#11AB96",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserGroup);
export default __webpack_public_path__ + "static/media/icUserGroup.b4c87d384035a8296467d4cebc835c24.svg";
export { ForwardRef as ReactComponent };